import { render, staticRenderFns } from "./AtomIconRouterButton.vue?vue&type=template&id=8f919c6c&scoped=true"
import script from "./AtomIconRouterButton.vue?vue&type=script&lang=ts"
export * from "./AtomIconRouterButton.vue?vue&type=script&lang=ts"
import style0 from "./AtomIconRouterButton.vue?vue&type=style&index=0&id=8f919c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f919c6c",
  null
  
)

export default component.exports